import { TextStyle } from '@superops/ui-design-system';
import React, { Suspense, useEffect, useState } from 'react';
import { SVGIcon } from '@superops/super-icons';
import { actionToast, EventEmitter, getTranslatedText } from '@nile/components';
import { getGuageOption } from '@nile/reports/src/modules/charts/utils/chart-transformation/charts';
import { KB_CONSTANTS, KB_ROUTE } from '@nile/rmm/src/modules/knowledge-base';
const ReactECharts = React.lazy(() => import('echarts-for-react'));

let broadcastChannel;
if (BroadcastChannel) {
  broadcastChannel = new BroadcastChannel('SuperShare');
}

function ImportProgress(props) {
  const { option } = props;
  const { intl, tabContext, lang } = option;

  const [importStatus, setImportStatus] = useState('');

  broadcastChannel.onmessage = (event) => {
    const eventData = JSON.parse(event.data);
    const { context } = eventData;
    const payload = eventData?.payload;

    if (payload?.type === 'SERVER_EVENT' && context === 'importUpdate') {
      const importData = payload?.data?.import;

      if (importData?.importId === option?.data?.importId) {
        if (
          payload?.event === 'PROGRESS' &&
          payload?.data?.import?.percentage
        ) {
          setImportStatus(importData);
        } else {
          localStorage.removeItem('articleImporting');
          props.closeToast();
          actionToast(
            'success',
            'common.app.kb.article.import.progress.completed',
            {
              title: getTranslatedText(intl, 'common.label.view.imports'),
              action: () => {
                try {
                  tabContext.openTab({
                    module: 'IT_DOCS',
                    id: 'itDocs',
                    url: `${KB_ROUTE.COLLECTION_VIEW}/${importData?.details?.parentId}`
                  });
                } catch (error) {}
                setTimeout(
                  () =>
                    EventEmitter.dispatch(
                      KB_CONSTANTS.KB_LIST_TABLE_REFETCH_EVENT
                    ),
                  100
                );
              }
            },
            'en',
            {
              position: 'top-center',
              autoClose: false
            }
          );
        }
      }
    }
  };

  return (
    <div className="flex fcol g10">
      <div className="flex g5">
        <div>
          <Suspense fallback={<i>loading...</i>}>
            <ReactECharts
              option={getGuageOption(
                [
                  {
                    value: importStatus?.['%'] || importStatus?.percent || 0
                  }
                ],
                {
                  hideDetails: true,
                  progressConfig: '2px',
                  progressColor: '#00D247'
                }
              )}
              opts={{
                width: '40px',
                height: '40px',
                renderer: 'svg',
                padding: '2px'
              }}
              style={{ height: '45px' }}
              notMerge
              lazyUpdate
            />
          </Suspense>
        </div>
        <div className="flex fcol g5">
          <TextStyle weight="Bold">
            {getTranslatedText(
              intl,
              'common.app.kb.article.import.progress.title'
            )}
          </TextStyle>
          <TextStyle variation="subdued">
            {getTranslatedText(
              intl,
              'common.app.kb.article.import.progress.desc'
            )}
          </TextStyle>
        </div>
      </div>
      {option?.fileCount > 0 && (
        <div className="flex g8">
          <SVGIcon name="Notes" />
          <TextStyle>
            {getTranslatedText(
              intl,
              'common.app.kb.article.import.progress.meta',
              { count: option?.fileCount || 0 }
            )}
          </TextStyle>
        </div>
      )}
    </div>
  );
}

export default ImportProgress;
